<script>
	import Rating from "../discover/Rating.vue"
	import locationIcon from "../../images/location-pin-secondary.svg"
	import proMemberIcon from '../../images/pro-member-tag.svg'
	export default {
		props: {
			artists: Array,
			city: Object,
      isProd: Boolean,
			country: Object,
			artType: Object,
			header: String,
			packagePrice: String,
			showArtists: Boolean,
		},
		data() {
			return {
				locationIcon: locationIcon,
				proMemberIcon: proMemberIcon,
				domain: window.location.origin,
			};
		},
		methods: {
			formattedAmount(amount) {
				if (amount != '') {
					return Math.round(amount).toLocaleString()
				} else {
					return 0
				}
			},
			formattedTax(amount, percentage ) {
				if (amount != '') {
					let inputPrice = (amount * percentage) / 100;
					return Math.round(inputPrice);
				} else {
					return 0
				}
			},
		},
		mounted() {
		},
		components: {
			Rating
		},
	}
</script>
<template>
  <section class="artist-list pb-3">
		<div v-if="showArtists" class="pb-3">
			<p class="d-flex mb-4 ms-5 ">{{ header }}</p>
			<a
				v-for="artist in artists"
				:key="artist.slug"
				:href="`https://soulartists.net/artist/${artist.slug}`"
				class="ai-item d-flex">
				<div class="ai-item__avatar mobile-avatar col-5">
					<div class="ai-avatar-container">
						<div class="overflow-hidden">
							<img :src="artist && artist.avatar && artist.avatar.large ? artist.avatar.large : `${domain}/images/default-avatar-img.jpg`" :alt="artist.stage_name" class="ai-item__avatar">
							<img v-if="artist.featured" :src="proMemberIcon" class="pro-member-badge-mobile" alt="pro member badge">
						</div>
					</div>
				</div>
				<div class="ai-item-all-info position-relative col-6 p-0">
					<div class="ai-item__info">
						<div class="d-flex align-items-center mb-1">
							<h3 class="ai-item__name text-capitalize mb-0">
								{{ artist.stage_name ? artist.stage_name : artist.full_name }}
							</h3>
							<img v-if="artist.featured" src='/assets/pro-member-tag.svg' class="pro-member-badge" alt="pro member badge">
						</div>
						<div class="d-flex align-items-center">
							<img :src="locationIcon" style="width: 10px; height: 15px;" alt="location"/>
							<p v-if="isProd" class="discover-item__desc ms-1 lh-1 text-truncate">
								{{ artist.city ? artist.city.name : '' }}, {{ artist.location ? artist.location.name : '' }}
								{{ artist.art_type ? ' • ' + artist.art_type.name : '' }}
							</p>
							<p v-else class="discover-item__desc ms-1 lh-1 text-truncate">
								Dubai, UAE • musicians 
							</p>
						</div>
						<rating
							class="ai-item__rating"
							v-if="artist.overall_rating > 0"
							:rating="artist.overall_rating"
							:reviews_count="artist.reviews_count"
						/>
						<p v-if="isProd" class="ai-item__specialities mt-1 lh-1 text-truncate">
							{{ artist.specialities.map(specialities => (specialities.name)).join(', ') }}
						</p>
						<p v-else class="ai-item__specialities mt-1 lh-1 text-truncate">
							Band, Cellist
						</p>
					</div>

					<div class="ai-item__price_info_mobile position-absolute bottom-0">
						<p v-if="isProd && artist.price_from" class="mb-0 lh-1">From</p>
						<p v-else-if="!isProd" class="mb-0 lh-1">From</p>
						<h2 v-if="isProd && artist.price_from" class="mt-0 lh-1">
							{{ artist.price_from.currency }} {{ formattedAmount(artist.price_from.amount.toLocaleString()) }}
						</h2>
						<h2 v-else-if="!isProd" class="mt-0 lh-1">
							AED 1000
						</h2>
						<p
							v-if="isProd && artist.price_from"
							class="small mb-1">
							+ {{ artist.price_from.currency }} {{ formattedTax(artist.price_from.amount * artist.tax_percentage) }} taxes and charges
						</p>
						<p
							v-else-if="!isProd"
							class="small mb-1">
							+ AED 57.5 taxes and charges
						</p>
					</div>
				</div>
				<div class="ai-item__price ms-auto">
					<div class="ai-item__price_info">
						<p v-if="isProd && artist.price_from" class="mb-0 lh-1">From</p>
						<p v-else-if="!isProd" class="mb-0 lh-1">From</p>
						<h2 v-if="isProd && artist.price_from" class="mt-0 lh-1">
							{{ artist.price_from.currency }} {{ formattedAmount(artist.price_from.amount.toLocaleString()) }}
						</h2>
						<h2 v-else-if="!isProd" class="mt-0 lh-1">
							AED 1000
						</h2>
						<p
							v-if="isProd && artist.price_from"
							class="small mb-1">
							+ {{ artist.price_from.currency }} {{ formattedTax(artist.price_from.amount * artist.tax_percentage) }} taxes and charges
						</p>
						<p
							v-else-if="!isProd"
							class="small mb-1">
							+ AED 57.5 taxes and charges
						</p>
						<a class="ai-item__more primary" :href="`https://soulartists.net/artist/${artist.slug}`">
							Check availability
						</a>
					</div>
				</div>
			</a>
		</div>
	</section>
</template>